import "core-js/es/number";
import "core-js/es/array";
import "core-js/features/url";
import "core-js/features/url-search-params";
import "core-js/es/string";
import "react-app-polyfill/ie11";
import { createRoot } from "react-dom/client";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import LogRocket from "logrocket";

import { App } from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

if (process.env.REACT_APP_LOGROCKET !== "true") {
  LogRocket.init("vo917h/mezze");

  LogRocket.getSessionURL(sessionURL => {
    Sentry.configureScope(scope => {
      scope.setExtra("sessionURL", sessionURL);
    });
  });
}

Sentry.init({
  dsn: "https://96554afdfeed45009b75d8e4dbbcd6cf@o252197.ingest.sentry.io/5853185",
  integrations: [ new Integrations.BrowserTracing() ],
  release: process.env.REACT_APP_RELEASE,
  environment: process.env.REACT_APP_ENVIRONMENT,
  tracesSampleRate: 0.3
});

serviceWorkerRegistration.register({
  onUpdate: (registration, installedWorker) => {
    // eslint-disable-next-line no-console
    console.log("Installing update...");

    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }

    installedWorker.postMessage({ action: "skipWaiting" });
  }
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(<App />);
